var _polygon, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "37.75 40.46 23.69 40.46 23.69 26.4 14.06 26.4 14.06 40.46 0 40.46 0 50.09 14.06 50.09 14.06 64.15 23.69 64.15 23.69 50.09 37.75 50.09 37.75 40.46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.46,
    cy: 31.72,
    r: 18.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.91,86.65v-11.44c0-2.76,1.2-5.4,3.34-7.15,6.83-5.6,17.53-9.11,32.2-9.11s25.37,3.51,32.2,9.11c2.13,1.75,3.34,4.39,3.34,7.15v11.44H28.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPersonIcon);
export default __webpack_public_path__ + "static/media/PlusPersonIcon.a486c9683d572c3eeaaa31a48ada7976.svg";
export { ForwardRef as ReactComponent };